module.exports = __webpack_public_path__ + "img/usha.40a00c98.jpg";